import { useMemo } from 'react';

import { AuthenticatorType } from 'backend-client-web';
import { AccountState } from 'client-core';

export default function useIsWebauthnOnly(accountState: AccountState): {
  isWebauthnOnly: boolean;
  isWebauthnPrfEnabled: boolean;
} {
  return useMemo(() => {
    return getAccountWebauthnStatus(accountState);
  }, [accountState]);
}

export function getAccountWebauthnStatus(accountState: AccountState) {
  const isWebauthnOnly =
    accountState.authenticators.some(
      (a) => a.authenticatorType === AuthenticatorType.SESSION_UNLOCK,
    ) && !accountState.authenticators.some((a) => a.authenticatorType === AuthenticatorType.PUSH);
  const isWebauthnPrfEnabled = accountState.authenticators.some(
    (a) => a.authenticatorType === AuthenticatorType.WEBAUTHN && a.webauthn,
  );
  return { isWebauthnOnly, isWebauthnPrfEnabled };
}
